module.exports = __webpack_public_path__ + "img/img05.103dcdaf.png";